import { DATE_PIPE_DEFAULT_OPTIONS, DATE_PIPE_DEFAULT_TIMEZONE, DatePipe, DatePipeConfig } from '@angular/common';
import { InjectionToken, LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

// type IrdDateConfig = {
//   predicate: () => boolean;
//   formats: { [key: string]: string };
// };

type IrdDateConfig = () => { [key: string]: string } | null;

export const IRD_DATE_FORMAT_CONFIG = new InjectionToken<IrdDateConfig>('IRD_DATE_FORMAT_CONFIG', {
  factory: () => {
    return () => null;
  },
});

@Pipe({
  name: 'irdDate',
})
export class IrdDatePipe extends DatePipe implements PipeTransform {
  private getConfig = inject<IrdDateConfig>(IRD_DATE_FORMAT_CONFIG);

  constructor() {
    const locale = inject(LOCALE_ID);
    const defaultTimezone = inject(DATE_PIPE_DEFAULT_TIMEZONE, { optional: true });
    const defaultOptions = inject<DatePipeConfig | null>(DATE_PIPE_DEFAULT_OPTIONS, { optional: true });

    super(locale, defaultTimezone, defaultOptions);
  }

  override transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string | null;
  override transform(value: null | undefined, format?: string, timezone?: string, locale?: string): null;
  override transform(value: Date | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string | null;
  override transform(value: Date | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string | null {
    format = this.getFormat(format, locale);
    return super.transform(value, format, timezone, locale);
  }

  private getFormat(format?: string, locale?: string): string | undefined {
    const config = this.getConfig();
    if (format && config && config[format]) {
      return config[format];
    } else if (format === 'shortDate' && (!locale || locale === 'en-US')) {
      // For some reason, Angular Date Pipe thinks Angular 'shortDate' format is M/d/yy
      return 'MM/dd/yyyy';
    } else {
      return format;
    }
  }
}
